import 'spectrum-colorpicker';
import 'spectrum-colorpicker/spectrum.css';
import 'Content/widgets/wcc-spectrum.scss';